import React from 'react';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { accountBlockedSelector } from '@common-reducers/UserSelectors';
import { useRouter } from '@common-reducers/hooks/use-router';

const ALLOWED_ROUTES = ['/admin-billing', '/account-subscription'];

const AccountBlocked: React.FC = () => {
    const isAccountBlocked = useAppSelector(accountBlockedSelector);
    const { navigate } = useRouter();

    if (!isAccountBlocked) return null;

    // Allow access to billing pages so user can update payment
    if (typeof window !== 'undefined') {
        const currentPath = window.location.pathname;
        if (ALLOWED_ROUTES.some(route => currentPath.startsWith(route))) {
            return null;
        }
    }

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999999,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '48px 40px',
                maxWidth: '480px',
                textAlign: 'center',
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            }}>
                <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    backgroundColor: '#fef2f2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                    fontSize: '28px',
                }}>
                    &#9888;
                </div>
                <h2 style={{
                    margin: '0 0 16px',
                    fontSize: '22px',
                    fontWeight: 700,
                    color: '#111',
                }}>
                    Account Suspended
                </h2>
                <p style={{
                    margin: '0 0 32px',
                    fontSize: '15px',
                    color: '#555',
                    lineHeight: 1.6,
                }}>
                    Your account has been suspended due to unpaid invoices. Please update your payment method to restore access.
                </p>
                <button
                    onClick={() => navigate('/admin-billing')}
                    style={{
                        backgroundColor: '#dc2626',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 32px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontSize: '15px',
                    }}
                >
                    Update Payment Method
                </button>
            </div>
        </div>
    );
};

export default AccountBlocked;
